
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  mixins: [staticBlockMixin],
  props: {
    maxWidth: {
      type: [Number, String],
      required: false,
      default: 0
    },
    fileType: {
      type: String,
      required: false,
      default: ''
    },
    fileSize: {
      type: String,
      required: false,
      default: ''
    },
    isSquare: {
      type: Boolean,
      required: false,
      default: false
    },
    isDeadline: {
      type: Boolean,
      required: false,
      default: null
    },
    noBorder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    linkTarget () {
      return !this.$isMobile ? '_blank' : '_self'
    },

    linkDownload () {
      return this.$isMobile ? this.mainFields.title?.value : null
    }
  },

  methods: {
    getFileType () {
      return this.fields?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.type?.toUpperCase() || this.fileType
    },

    checkIsDeadline () {
      if (this.isDeadline !== null) { return this.isDeadline }
      const deadline = this.fields?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.deadline
      return !deadline ? false : Date.now() > (deadline)
    },

    getFileSize () {
      return this.fields?.mainFields?.find((field: { code: string }) => field?.code === 'file')?.size || this.fileSize
    },

    getDownloadLink () {
      return this.mainFields.file?.origin ? `${this.$config.S3_DOMAIN}${this.mainFields.file.origin}` : ''
    },

    handleFileAction () {
      const downloadLink = this.getDownloadLink()

      if (this.$isMobile) {
        this.downloadFile(downloadLink)
      } else {
        window.open(downloadLink, '_blank')
      }
    },

    async downloadFile (url: string) {
      try {
      // * Загрузка файла фида с помощью axios
        const file = (await this.$axios.get(url, { responseType: 'blob' }))
          ?.data as Blob
        // * Создание элемента ссылки
        const linkElement = document.createElement('a')
        // * Установка пути ссылки на объект ссылки
        linkElement.href = URL.createObjectURL(file)
        // * Установка названия файла
        linkElement.download = this.mainFields.title?.value || null
        // * Внедрение элемента ссылки в body
        document.body.appendChild(linkElement)
        // * Вызов события клик ссылки
        linkElement.click()
        // * Удаление объекта ссылки
        URL.revokeObjectURL(linkElement.href)
        // * Удаление элемента ссылки
        document.body.removeChild(linkElement)
      } catch (error) {
        console.error(error)
      }
    }
  }
})
